import axios, { AxiosResponse } from 'axios';

export default class UploadService {
  public uploadFiles(files: File[], progressCallback: (n: number) => any): Promise<any> {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    return axios.post('/api/admin/upload/files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progressEvent => {
        const uploadPercentage = progressEvent.total ? Math.round((progressEvent.loaded / progressEvent.total) * 100) : 0;
        progressCallback(uploadPercentage);
      },
    });
  }

  public uploadArchiveFile(files: File[], progressCallback: (n: number) => any): Promise<any> {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    return axios.post('/api/admin/upload/zip', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progressEvent => {
        const uploadPercentage = progressEvent.total ? Math.round((progressEvent.loaded / progressEvent.total) * 100) : 0;
        progressCallback(uploadPercentage);
      },
    });
  }
}
